import React from "react";
import { WebsiteUrl } from '../common/Constants';
import Helmet from '../common/Helmet';

const TITLE = "Informazioni sul sito Calcolatore di Percentuali";
const DESCRIPTION = "Il sito del Calcolatore di Percentuali è una delle piattaforme più grandi per il calcolo delle percentuali, comprese le calcolazioni delle percentuali, gli aumenti e le diminuzioni, e le differenze percentuali. Offriamo oltre 100 calcolatori per calcolare le percentuali da 1 a 100.";
const KEYWORDS = "Calcolatore di percentuali, calcolo delle percentuali, calcolo degli aumenti e delle diminuzioni, differenza percentuale, calcolatore di percentuali da 1 a 100, calcolatore di percentuali";
const lang = "it";
const url = WebsiteUrl;
const OG_URL = `${WebsiteUrl}/${lang}/about/`;

const About = () => {
    return (
        <div>

            <Helmet
                TITLE={TITLE}
                WEBSITE_URL={url}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                LANG={lang}
            />
            <div className="p-3 mb-2 mainBackground text-white">
                <h1 style={{ fontSize: '24px', marginBottom: '15px' }}>
                    <b>Informazioni sul sito "Calcolatore di Percentuali"</b>
                </h1>
            </div>

            <p style={{ lineHeight: '1.6' }}>
                Benvenuti sul sito "Calcolatore di Percentuali", la piattaforma leader per strumenti di calcolo relativi alle percentuali.
                Il nostro obiettivo è offrire un'esperienza rapida e semplice per gli utenti che desiderano calcolare le percentuali per vari scopi.
                Che tu voglia <strong>calcolare la percentuale</strong> di qualsiasi valore, <strong>calcolare aumenti e diminuzioni</strong>, o anche <strong>differenze percentuali</strong>, troverai gli strumenti giusti qui.
                <br /><br />
                Il nostro sito offre oltre <strong>100 calcolatori specializzati</strong> per il calcolo delle percentuali, da 1 a 100, rendendolo il sito ideale per studenti, insegnanti, professionisti e chiunque abbia bisogno di effettuare calcoli rapidi e accurati.
                <br /><br />
                Siamo sempre impegnati ad aggiornare i nostri strumenti per soddisfare le esigenze degli utenti e fornire la migliore esperienza possibile. Goditi l'uso del sito "Calcolatore di Percentuali" per ottenere risultati rapidi e precisi nei tuoi calcoli.
            </p>

            <hr />

            <div className="p-3 mb-2 mainBackground text-white">
                <p style={{ lineHeight: '1.6' }}>
                    Se hai domande, desideri che il nostro team aggiunga nuovi calcolatori, o vuoi segnalare un problema con uno dei calcolatori, per favore contattaci via email:
                    <br />
                    <a href="mailto:info@percentager.net" style={{ color: 'white', textDecoration: 'underline' }}>info@percentager.net</a>
                </p>
            </div>

        </div>

    );
};

export default About;
